var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHwp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 45,
    rx: 2,
    fill: "#F2EDF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8158 10.5048C32.8158 10.1367 32.5175 9.83834 32.1494 9.83834H25.0568C24.6887 9.83834 24.3903 9.53995 24.3903 9.17188V6.82954C24.3903 6.46147 24.0919 6.16309 23.7239 6.16309L21.4711 6.16309C21.1031 6.16309 20.8047 6.46147 20.8047 6.82954V9.17188C20.8047 9.53995 20.5063 9.83834 20.1382 9.83834H13.0442C12.6761 9.83834 12.3777 10.1367 12.3777 10.5048V12.8374C12.3777 13.2054 12.6761 13.5038 13.0442 13.5038H32.1494C32.5175 13.5038 32.8158 13.2054 32.8158 12.8374V10.5048ZM11.7509 38.251C11.7509 38.6191 12.0492 38.9175 12.4173 38.9175H33.5843C33.9523 38.9175 34.2507 38.6191 34.2507 38.251V35.9184C34.2507 35.5504 33.9523 35.252 33.5843 35.252H16.0021C15.634 35.252 15.3356 34.9536 15.3356 34.5855L15.3356 31.1672C15.3356 30.7991 15.0373 30.5007 14.6692 30.5007H12.4165C12.0484 30.5007 11.75 30.7991 11.75 31.1672L11.75 37.0441C11.75 37.0443 11.7502 37.0445 11.7504 37.0445C11.7507 37.0445 11.7509 37.0447 11.7509 37.0449V38.251ZM24.8828 32.204C24.8828 33.4664 23.8594 34.4898 22.597 34.4898C21.3346 34.4898 20.3111 33.4664 20.3111 32.204C20.3111 30.9415 21.3346 29.9181 22.597 29.9181C23.8594 29.9181 24.8828 30.9415 24.8828 32.204ZM25.8587 21.4469C25.8587 23.2486 24.3982 24.7091 22.5965 24.7091C20.7949 24.7091 19.3344 23.2486 19.3344 21.4469C19.3344 19.6453 20.7949 18.1847 22.5965 18.1847C24.3982 18.1847 25.8587 19.6453 25.8587 21.4469ZM29.8575 21.4469C29.8575 25.457 26.6066 28.7078 22.5965 28.7078C18.5865 28.7078 15.3356 25.457 15.3356 21.4469C15.3356 17.4368 18.5865 14.186 22.5965 14.186C26.6066 14.186 29.8575 17.4368 29.8575 21.4469Z",
    fill: "#773DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHwp);
export default __webpack_public_path__ + "static/media/ic_hwp.9c0e9dcc27ef6eee3cc78a9e6ceba8dd.svg";
export { ForwardRef as ReactComponent };